import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { IntlMessage } from "app/components/Intl";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadArea, { FileType } from "../../../../components/FileUploadArea";
import { downloadOcrCsvTemplate } from "../../Services/ConnectionService";
const OcrCsvUploadDialog = (props) => {
  const { open, setOpen, onConfirm, connectionId } = props;
  const [hasFiles, setHasFiles] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(void 0);
  const [downloading, setDownloading] = useState(false);
  const handleDownloadTemplate = async () => {
    setDownloading(true);
    try {
      const response = await downloadOcrCsvTemplate(connectionId);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const fileName = response.headers["x-filename"] || "ocr-csv-template.csv";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading OCR CSV template:", error);
    } finally {
      setDownloading(false);
    }
  };
  return /* @__PURE__ */ React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open, onClose: () => setOpen(false), "aria-labelledby": "confirm-dialog" }, /* @__PURE__ */ React.createElement(DialogTitle, { id: "ocr-csv-upload-dialog" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "upload.ocrCsv.title" })), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(DialogContentText, { marginBottom: (theme) => theme.spacing(1) }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "upload.ocrCsv.helpMessage" })), /* @__PURE__ */ React.createElement(Box, { marginBottom: 2, textAlign: "center", py: 1 }, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "outlined",
      startIcon: /* @__PURE__ */ React.createElement(DownloadIcon, null),
      onClick: handleDownloadTemplate,
      disabled: downloading
    },
    /* @__PURE__ */ React.createElement(
      FormattedMessage,
      {
        id: downloading ? "upload.ocrCsv.downloadingTemplate" : "upload.ocrCsv.downloadTemplate"
      }
    )
  )), /* @__PURE__ */ React.createElement(
    FileUploadArea,
    {
      types: [FileType.Csv],
      disabled: false,
      showSuccessMessage: false,
      onChange: (files) => {
        setHasFiles(files.length > 0);
        setUploadedFiles(files);
      }
    }
  )), /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(Button, { variant: "outlined", onClick: () => setOpen(false) }, /* @__PURE__ */ React.createElement(IntlMessage, { value: "no" })), /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      onClick: () => {
        setOpen(false);
        onConfirm(uploadedFiles);
      },
      disabled: !hasFiles
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "button.start" })
  )));
};
OcrCsvUploadDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onConfirm: PropTypes.func,
  connectionId: PropTypes.string
};
export default OcrCsvUploadDialog;
